import { useFetch } from '@/hooks/useFetch'
import { showError } from '@/shared/toast'
import { css } from '@emotion/react'
import type { ChangeEvent } from 'react'
import { useEffect, useState } from 'react'
import { tableName } from '@/types/tableName'

type Option = {
  label: string
  value: string
}

type Props = {
  initialValue?: string
  tableName: tableName
  id: string
  onChange?: (value: string) => void
}

const style = css`
  width: 25rem;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #cfd7e6;
  border-radius: 4px;
  background: #fff;
`

export const HistorySelect = ({
  initialValue,
  tableName,
  id,
  onChange,
}: Props) => {
  const [options, setOptions] = useState<Option[]>([])
  const [value, setValue] = useState('')
  const { data, error }: any = useFetch<
    { id: number; startDate: string; endDate?: string }[]
  >(`/api/${tableName}/${id}/history`)

  useEffect(() => {
    if (data && data.length > 0) {
      const newOptions: Option[] = []
      for (let i = 0; i < data.length; i++) {
        const startDate = new Date(data[i].startDate)
        const endDate = data[i].endDate ? new Date(data[i].endDate) : null
        const startDateString = new Intl.DateTimeFormat('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).format(startDate)
        const endDateString = endDate
          ? new Intl.DateTimeFormat('ja-JP', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }).format(endDate)
          : ''
        newOptions.push({
          label: startDateString + ' ~ ' + endDateString,
          value: String(data[i].id),
        })
      }
      setOptions(newOptions)

      const initialOption = newOptions.find(
        (opt: any) => opt.value === initialValue,
      )
      setValue(initialOption?.value || '')
      return
    }

    setOptions([])
    setValue('')
  }, [data, initialValue])

  useEffect(() => {
    if (error) {
      showError('履歴の取得に失敗しました。')
    }
  }, [error])

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const nextValue = event.target.value
    setValue(nextValue)
    onChange?.(nextValue)
  }

  return (
    <select
      css={style}
      value={value}
      name={`${tableName}History`}
      onChange={handleChange}
      aria-label="履歴"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}
